import type { RootState } from "@/rtkQuery/store";
export const selectIsCartOpen = (state: RootState) =>
  state.cartDrawer.isCartOpen;
export const selectItemQuantities = (state: RootState) =>
  state.cartDrawer.itemQuantities;